// Lazy loading utilities for heavy components
import { lazy } from 'react';

// Lazy load heavy chart components
export const LazyAreaChart = lazy(() => 
  import('recharts').then(module => ({ default: module.AreaChart }))
);

export const LazyLineChart = lazy(() => 
  import('recharts').then(module => ({ default: module.LineChart }))
);

export const LazyBarChart = lazy(() => 
  import('recharts').then(module => ({ default: module.BarChart }))
);

export const LazyPieChart = lazy(() => 
  import('recharts').then(module => ({ default: module.PieChart }))
);

export const LazyResponsiveContainer = lazy(() => 
  import('recharts').then(module => ({ default: module.ResponsiveContainer }))
);

export const LazyXAxis = lazy(() => 
  import('recharts').then(module => ({ default: module.XAxis }))
);

export const LazyYAxis = lazy(() => 
  import('recharts').then(module => ({ default: module.YAxis }))
);

export const LazyCartesianGrid = lazy(() => 
  import('recharts').then(module => ({ default: module.CartesianGrid }))
);

export const LazyTooltip = lazy(() => 
  import('recharts').then(module => ({ default: module.Tooltip }))
);

export const LazyArea = lazy(() => 
  import('recharts').then(module => ({ default: module.Area }))
);

export const LazyLine = lazy(() => 
  import('recharts').then(module => ({ default: module.Line }))
);

export const LazyBar = lazy(() => 
  import('recharts').then(module => ({ default: module.Bar }))
);

// Lazy load framer-motion components
export const LazyMotion = lazy(() => 
  import('framer-motion').then(module => ({ default: module.motion }))
);

export const LazyAnimatePresence = lazy(() => 
  import('framer-motion').then(module => ({ default: module.AnimatePresence }))
);

// Date utility lazy loader
export const loadDateFns = () => import('date-fns');

// Utility function to preload critical chunks
export const preloadCriticalChunks = () => {
  // Only preload in production and when user is likely to use these features
  if (import.meta.env.PROD && 'requestIdleCallback' in window) {
    requestIdleCallback(() => {
      // Preload date utilities for dashboard
      loadDateFns();
      
      // Preload chart components for data visualization
      import('recharts');
      
      // Preload motion for animations
      import('framer-motion');
    }, { timeout: 2000 });
  }
};